'use client';
import { usePrevious } from '@mnd-frontend/hooks';
import { hierarchy, pack } from 'd3-hierarchy';
import { useMemo } from 'react';

export default function usePackLayout(
  data: any,
  dataKey: any,
  width: any,
  height: any,
  padding: any,
) {
  // saves updates and the pack layout based upon the diameter anyway
  const diameter = Math.min(width || 0, height);

  const nodes = useMemo(() => {
    if (diameter === 0) return [];

    // expects hierarchical nodes
    // returns value, parent, children, depth (0 for root), height (0 for leaves)
    const children = data.filter((d: any) => d[dataKey] > 0);
    const nodes = hierarchy({ children })
      .sum((d: any) => d[dataKey] || 1) // adds "value" as sum of it's children
      .sort((a: any, b: any) => b.value - a.value);

    // expects hierarchical nodes
    // mutates x, y
    pack().size([diameter, diameter]).padding(padding)(nodes);

    // flatten to array, retain only leave nodes
    return nodes.leaves().filter((d: any) => d.parent);
  }, [data, dataKey, diameter, padding]);

  const prevWidth = usePrevious(nodes.length && width);
  const offset = (width - (prevWidth || diameter)) / 2;
  if (offset) nodes.map((d: any) => (d.x += offset));

  return nodes;
}
